import { Http } from 'lib'

import { PageViewRegisterState, pageViewRegisterInitialState } from './store/State'

import { setPath, reset, PageViewRegisterAction } from './store/Actions'

import pageViewRegisterReducer from './store/Reducer'
import ServiceProviderBase from 'lib/ServiceProviderBase'
import apiUrlsAddresses from 'config/constants/api-urls-addresses'

export class PageViewRegisterService extends ServiceProviderBase<PageViewRegisterState, PageViewRegisterAction> {
  constructor() {
    super(pageViewRegisterInitialState)
  }

  reduce(state: PageViewRegisterState, action: PageViewRegisterAction): PageViewRegisterState {
    return pageViewRegisterReducer(state, action)
  }

  async registerPath(location: string): Promise<void> {
    const [, , error] = await Http.post(apiUrlsAddresses.eventLogger.pageView(), {
      previousPage: this.state.path,
      currentPage: location
    })

    if (error) {
      // tslint:disable:no-console
      console.log('[page-view]', error)
    }

    this.dispatch(setPath(location))
  }

  reset() {
    this.dispatch(reset())
  }
}

let instance: PageViewRegisterService = null

export default (() => {
  if (!instance) {
    instance = new PageViewRegisterService()
  }
  return instance
})()
